var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "90%",
            wrapperClosable: false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading.fullscreen.lock",
                  value: _vm.loading,
                  expression: "loading",
                  modifiers: { fullscreen: true, lock: true },
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "生成详情", name: "1" } },
                    [
                      _c(
                        "div",
                        [
                          _vm.DevData.some(
                            (item) => item.TaskPlanDetailStatus == 0
                          )
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.State == 1,
                                  },
                                  on: { click: _vm.startExecution },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.State == 0
                                        ? "开始生成"
                                        : _vm.State == 1
                                        ? "生成中"
                                        : _vm.State == 2
                                        ? "继续生成"
                                        : ""
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.DevData.some(
                            (item) => item.TaskPlanDetailStatus == 0
                          ) && _vm.State != 2
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.suspend },
                                },
                                [_vm._v("暂停")]
                              )
                            : _vm._e(),
                          _c("el-input", {
                            staticStyle: {
                              width: "300px",
                              "margin-left": "10px",
                            },
                            attrs: {
                              clearable: "",
                              placeholder: "请输入设备名称/编号",
                            },
                            model: {
                              value: _vm.DeviceName,
                              callback: function ($$v) {
                                _vm.DeviceName = $$v
                              },
                              expression: "DeviceName",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-tag",
                                { attrs: { type: "info", size: "medium " } },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#67c23a" } },
                                    [_vm._v(" 生成完成 " + _vm._s(_vm.numTo))]
                                  ),
                                  _vm._v(" / "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#f56c6c" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.DevData.length - _vm.numTo) +
                                          " 未生成"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "DevData",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.DevData,
                            "row-class-name": _vm.rowclassname,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "序号",
                              width: "50",
                              type: "index",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备编号",
                              align: "center",
                              prop: "DeviceCode",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备名称",
                              align: "center",
                              prop: "device_name",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备型号",
                              align: "center",
                              prop: "model_number",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备规格",
                              align: "center",
                              prop: "specification",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "安装位置",
                              align: "center",
                              prop: "InstallationAreaName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "生成状态",
                              align: "center",
                              prop: "State",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.TaskPlanDetailStatus == 0
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("未生成")]
                                        )
                                      : _vm._e(),
                                    scope.row.TaskPlanDetailStatus == 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [_vm._v("生成完成")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "生成进度",
                              align: "center",
                              prop: "loadingNum",
                              width: "300px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-progress", {
                                      attrs: {
                                        "text-inside": true,
                                        "stroke-width": 20,
                                        percentage: scope.row.loadingNum,
                                      },
                                    }),
                                    scope.row.loading
                                      ? _c("span", [
                                          _vm._v(
                                            "已用时" +
                                              _vm._s(scope.row.loadingmm) +
                                              "秒"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "80" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.TaskPlanDetailStatus == 1
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openList(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("详情")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "计划详情", name: "2" } },
                    [
                      _c(
                        "el-collapse",
                        {
                          model: {
                            value: _vm.collapseNames,
                            callback: function ($$v) {
                              _vm.collapseNames = $$v
                            },
                            expression: "collapseNames",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "1.设备分类", name: "1" } },
                            [
                              _c("div", [
                                _vm._v(
                                  " 设备分类： " +
                                    _vm._s(
                                      _vm.dataInfo.device_TaskPlan
                                        .DeviceTypeName
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "2.设备信息", name: "2" } },
                            [
                              _c(
                                "el-table",
                                {
                                  ref: "DevData",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.dataInfo.device_TaskPlanDetails,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "序号",
                                      width: "50",
                                      type: "index",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "设备编号",
                                      align: "center",
                                      prop: "DeviceCode",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "设备名称",
                                      align: "center",
                                      prop: "device_name",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "设备型号",
                                      align: "center",
                                      prop: "model_number",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "设备规格",
                                      align: "center",
                                      prop: "specification",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "生产厂家名称",
                                      align: "center",
                                      prop: "manufacturer",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "维修商名称",
                                      align: "center",
                                      prop: "maintenance",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "安装位置",
                                      align: "center",
                                      prop: "InstallationAreaName",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "购置日期",
                                      align: "center",
                                      prop: "purchase_date",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.purchase_date
                                                    ? _vm
                                                        .moment(
                                                          scope.row
                                                            .purchase_date
                                                        )
                                                        .format("YYYY-MM-DD")
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "状态",
                                      align: "center",
                                      prop: "State",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.State == 0
                                              ? _c("el-tag", [_vm._v("停机")])
                                              : _vm._e(),
                                            scope.row.State == 1
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: { type: "success" },
                                                  },
                                                  [_vm._v("开机")]
                                                )
                                              : _vm._e(),
                                            scope.row.State == 2
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: { type: "warning" },
                                                  },
                                                  [_vm._v("故障")]
                                                )
                                              : _vm._e(),
                                            scope.row.State == 3
                                              ? _c(
                                                  "el-tag",
                                                  { attrs: { type: "danger" } },
                                                  [_vm._v("报废")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "3.备件信息", name: "3" } },
                            [
                              _c(
                                "el-table",
                                {
                                  ref: "MaterialsData",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.dataInfo.device_TaskPlanMaterials,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "序号",
                                      width: "50",
                                      type: "index",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "备件编号",
                                      align: "center",
                                      prop: "Code",
                                      sortable: "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "备件名称",
                                      align: "center",
                                      prop: "Name",
                                      sortable: "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "备件类型",
                                      align: "center",
                                      prop: "MaterialTypeName",
                                      sortable: "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "备件规格",
                                      align: "center",
                                      prop: "Spec",
                                      sortable: "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "单位",
                                      align: "center",
                                      prop: "storageName",
                                      sortable: "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "货位",
                                      align: "center",
                                      prop: "LocalName",
                                      sortable: "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "库存数量",
                                      align: "right",
                                      prop: "Nums_N",
                                      sortable: "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "数量",
                                      align: "center",
                                      prop: "Num",
                                      sortable: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-collapse-item",
                            { attrs: { title: "4.计划信息", name: "4" } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "form",
                                  attrs: {
                                    model: _vm.dataInfo.device_TaskPlan,
                                    "label-width": "140px",
                                    disabled: "",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "保养计划名称",
                                                prop: "Name",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder:
                                                    "请输入保养计划名称",
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataInfo.device_TaskPlan
                                                      .Name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataInfo
                                                        .device_TaskPlan,
                                                      "Name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataInfo.device_TaskPlan.Name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "计划开始日期",
                                                prop: "StartTime",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                attrs: {
                                                  type: "date",
                                                  "value-format": "yyyy-MM-dd",
                                                  placeholder: "选择日期",
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataInfo.device_TaskPlan
                                                      .StartTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataInfo
                                                        .device_TaskPlan,
                                                      "StartTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataInfo.device_TaskPlan.StartTime",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "计划结束日期",
                                                prop: "EndTime",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                attrs: {
                                                  type: "date",
                                                  "value-format": "yyyy-MM-dd",
                                                  placeholder: "选择日期",
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataInfo.device_TaskPlan
                                                      .EndTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataInfo
                                                        .device_TaskPlan,
                                                      "EndTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataInfo.device_TaskPlan.EndTime",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "描述", prop: "Remarks" },
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "600px",
                                          overflow: "auto",
                                          border: "1px solid #e2e2e2",
                                          padding: "10px",
                                          "background-color": "#f5f7fa",
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.dataInfo.device_TaskPlan.Remarks
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
        ]
      ),
      _c("WorkOrderList", { ref: "WorkOrderList" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }